




































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  Task,
  ScheduledTask,
  isScheduledTask,
  localiseTaskType,
} from "@/data/models/Task";
import TaskDetailsComponent from "@/components/scheduling/TaskDetails.vue";
import TaskSchedulingInfoComponent from "@/components/scheduling/TaskSchedulingInfo.vue";
import { SchedulingModule } from "@/store/modules/SchedulingModule";
import { getTaskTypeColor } from "@/data/models/SchedulingSettings";
import { formatDateWithWeekday } from "@/utils/DateFormatter";
import { formatProjectNameAndNumber } from "@/data/models/ProjectDetails";
import { COLOR_WHITE_BACKGROUND, COLOR_WHITE_BACKGROUND_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";

@Component({
  components: {
    "task-details": TaskDetailsComponent,
    "task-scheduling-info": TaskSchedulingInfoComponent,
  },
})
export default class TaskItemComponent extends Vue {
  @Prop()
  task!: Task | ScheduledTask;

  @Prop()
  highlightedTaskId!: string | null;

  get cardStyle() {
    const showBorder =
      this.isFocusedTask || this.task.id == this.highlightedTaskId;

    // The resting border matches the card, so only a focused card shows a frame (dark mode too).
    const surface = themed(COLOR_WHITE_BACKGROUND, COLOR_WHITE_BACKGROUND_DARK);

    return {
      border: `2px solid ${showBorder ? "red" : surface}`,
      background: surface,
    };
  }

  get usersForSelection() {
    return SchedulingModule.usersQualifiedForFocusedTask;
  }

  get taskTypeDescription() {
    return localiseTaskType(this, this.task.taskType);
  }

  get isFocusedTask() {
    return this.task.id == SchedulingModule.focusedTask?.id;
  }

  get taskSpanStyle() {
    return {
      background: getTaskTypeColor(
        this.task.taskType,
        SchedulingModule.schedulingSettings.planningBoardSettings
      ),
    };
  }

  get isConfirmed() {
    const task = this.task;
    return isScheduledTask(task) ? task.wasConfirmed : false;
  }

  get earliestStartDate() {
    const { earliestStartDate } = this.task;

    if (!earliestStartDate) {
      return "";
    }

    return this.$t("scheduling.tasks.formatStartingAt", [
      formatDateWithWeekday(earliestStartDate, {
        showYearIfNotCurrentYear: true,
      }),
    ]);
  }

  onFocusOnTask() {
    const task = this.task;

    const data =
      SchedulingModule.tasksOfAllUsersLookup.getScheduledTask(task.id) ?? task;

    if (SchedulingModule.focusedTask?.id === data.id) {
      return;
    }

    SchedulingModule.restoreInitialDataOfFocusedTask();
    SchedulingModule.setFocusedTask({
      ...data,
    });
  }

  get projectNameAndNumber() {
    const { projectName, projectNumber } = this.task;

    return formatProjectNameAndNumber(projectName, projectNumber, " ");
  }
}
